export default {"src":"/_next/static/media/marker.b5c7f5be.svg","height":84,"width":75,"blurWidth":0,"blurHeight":0};